export const BASKET_KEY = 'RDG_BASKET';
export const VOUCHER_KEY = 'RDG_VOUCHER';
export const GIFT_WRAPPING_KEY = 'RDG_VOUCHER';
export const SUSTAINABLE_PACKAGING_KEY = 'RDG_SUSTAINABLE_PACKAGING';
